const ShouldBeDeleted = {
    YES: 'Igen',
    NO: 'Nem',
    SHOULD_BE_CORRECTED: 'Lehet javítani',
};

export default ShouldBeDeleted;